/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useInfluencer } from "@/Providers/Influencer";
import { useGeneralSettings } from "@/Providers/General";

import { useToast } from "@/shadcnComponents/ui/use-toast";

import axios from "axios";
import mixpanel from "mixpanel-browser";
import Confetti from "react-confetti";
import { BrandCollabSidebar } from "./BrandCollabComponents/BrandCollabSidebar";
import { BrandCollabStepper } from "./BrandCollabComponents/BrandCollabStepper";

import { AcceptOpportunityPage } from "./BrandCollabSteps/AcceptOpportunityPage";
import { ShareDraftPage } from "./BrandCollabSteps/ShareDraftPage";
import { GoLivePage } from "./BrandCollabSteps/GoLivePage";
import { ScreenAlert } from "@/Pages/SmallScreenAlert/ScreenAlert";

const host: string = import.meta.env.VITE_BACKEND_SERVER_URL;

export const BrandCollabsDetails = () => {
  const influencerState = useInfluencer();
  const generalState = useGeneralSettings();
  // const staticDataState = useStaticData();
  // const authState = useAuth();

  const { toast } = useToast();

  const [loadingTracking, setLoadingTracking] = useState(false);
  const [collab, setCollab] = useState(null);
  const [PostData, SetPostData] = useState({
    response: "pending",
    whyInterested: "",
    trackingLink: "",
    draftMessageLink: "",
  });
  const [declineReason, setDeclineReason] = useState("");
  const [declineDescription, setDeclineDescription] = useState("");

  const queryParam = new URLSearchParams(window?.location?.search);
  const collabId = queryParam?.get("key");
  const section = queryParam?.get("section");
  const [currentStep, setCurrentStep] = useState(1);
  const [openAcceptSuccess, setOpenAcceptSuccess] = useState(false);
  const [isDraftSaving, setIsDraftSaving] = useState(false);

  useEffect(() => {
    setCurrentStep(parseInt(section || "1"));
  }, []);

  useEffect(() => {
    mixpanel.track("Influencer Brand Collab Details Page Visited");
    const getAnchorsCollabDetails = async () => {
      generalState?.setLoading(true);
      const response = await influencerState?.getAllAnchorsCollabDetails(
        collabId
      );
      if (response?.success === true) {
        generalState?.setLoading(false);
        setCollab(response?.collabDetails?.[0]);
      } else {
        generalState?.setLoading(false);
      }
    };
    getAnchorsCollabDetails();
  }, []);

  useEffect(() => {
    if (collab) {
      SetPostData((prev) => ({
        ...prev,
        whyInterested: collab?.whyInterested,
        response: collab?.response,
        trackingLink: collab?.trackingLink,
      }));
    }
  }, [collab]);

  const handleSubmit = async (e, status) => {
    e?.preventDefault();
    const isDeclined = status === "rejected";
    generalState?.setLoading(true);
    const response = await influencerState?.updateAnchorsCollabDetails(
      collabId,
      {
        ...PostData,
        response: status,
        influencerDecline: {
          isDeclined,
          influencerReason: isDeclined ? declineReason : "",
          influencerComment: isDeclined ? declineDescription : "",
        },
      }
    );
    if (response?.success === true) {
      generalState?.setLoading(false);
      if (status !== "rejected") {
        handleConfettiClick(e);
      }

      const response2 = await influencerState?.getAllAnchorsCollabDetails(
        collabId
      );
      if (response2?.success === true) {
        generalState?.setLoading(false);
        setCollab(response2?.collabDetails?.[0]);
      } else {
        generalState?.setLoading(false);
      }
    } else {
      generalState?.setLoading(false);
    }
  };

  const handleTrackPost = async ({ anchorsCollabId, postUrl }) => {
    try {
      setLoadingTracking(true);
      const response = await axios.get(
        `${host}/collab/brand/getPostTracking/?collabId=${collabId}&postUrl=${postUrl}&anchorsCollabId=${anchorsCollabId}`,
        {
          headers: {
            jwtToken: localStorage.getItem("jwtToken"),
          },
        }
      );

      if (response.status !== 200) {
        return { Error: response.data.error };
      } else {
        setCollab({
          ...collab,
          postTracking: response.data?.postTracking,
        });

        // toast({
        //   title: `Post Tracking refreshed successfully`,
        // });
        console.log("Post Tracking refreshed successfully");
      }
    } catch (e) {
      return { Error: e.response.data.error };
    } finally {
      setLoadingTracking(false);
    }
  };

  // -------- confetti explosion on accepting the collab ---------
  const [showConfetti, setShowConfetti] = useState(false);
  const [confettiConfig, setConfettiConfig] = useState({
    x: window.innerWidth / 2,
    y: window.innerHeight / 2,
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const handleConfettiClick = (e) => {
    const { clientX, clientY } = e;
    setConfettiConfig({
      x: clientX,
      y: clientY,
      width: window.innerWidth,
      height: window.innerHeight,
    });
    setShowConfetti(true);

    setTimeout(() => {
      setShowConfetti(false);
    }, 3000);
  };

  // --------------- Linkedin Editor ----------------
  const saveData = async (data) => {
    generalState?.setLoading(true);
    const response = await influencerState?.updateAnchorsCollabDetails(
      collabId,
      { ...data }
    );
    if (response?.success === true) {
      generalState?.setLoading(false);

      const response2 = await influencerState?.getAllAnchorsCollabDetails(
        collabId
      );
      if (response2?.success === true) {
        generalState?.setLoading(false);
        setCollab(response2?.collabDetails?.[0]);
        return { success: true };
      } else {
        generalState?.setLoading(false);
      }
    } else {
      generalState?.setLoading(false);
    }
  };

  const uploadImages = async (data) => {
    if (data.length > 0) {
      const uploadPromises = data.map(async (item, index) => {
        if (item instanceof File) {
          // Replace the file name
          const newFileName = `${index + 1}${item.name.slice(
            item.name.lastIndexOf(".")
          )}`; // Custom name with original extension

          const renamedFile = new File([item], newFileName, {
            type: item.type,
            lastModified: item.lastModified,
          });

          const formData = new FormData();
          formData.append("file", renamedFile);
          const result = await influencerState?.uploadInfluCollabImage(
            formData
          );
          if (result?.success) {
            return result?.result?.Location;
          }
          return null; // Return null if the upload fails
        }
        return item; // Return the item itself if it's not a File
      });

      const uploadedImages = await Promise.all(uploadPromises);
      return uploadedImages.filter((url) => url !== null); // Filter out null values
    }
    return [];
  };

  const uploadVideos = async (data) => {
    if (data.length > 0) {
      const uploadPromises = data.map(async (item, index) => {
        if (item instanceof File) {
          // Replace the file name
          const newFileName = `${index + 1}${item.name.slice(
            item.name.lastIndexOf(".")
          )}`; // Custom name with original extension

          const renamedFile = new File([item], newFileName, {
            type: item.type,
            lastModified: item.lastModified,
          });

          const formData = new FormData();
          formData.append("file", renamedFile);
          const result = await influencerState?.uploadInfluCollabVideos(
            formData
          );
          if (result?.success) {
            return result?.result?.Location;
          }
          return null; // Return null if the upload fails
        }
        return item; // Return the item itself if it's not a File
      });

      const uploadedImages = await Promise.all(uploadPromises);
      return uploadedImages.filter((url) => url !== null); // Filter out null values
    }
    return [];
  };

  const handleSaveLinkedinDraft = async ({ editorState }) => {
    mixpanel.track(
      "Influencer Brand Collab Details - Linkedin Editor : Save Draft - Clicked "
    );

    if (!editorState?.content?.trim()) {
      toast({
        title: "Please write something before saving the draft",
        variant: "destructive",
      });
      return;
    }
    setIsDraftSaving(true);
    const updatedImages = await uploadImages(editorState?.images || []);
    const updatedVideos = await uploadVideos(editorState?.video || []);

    // editor state not have docid create new draft
    if (!editorState?.docid) {
      await saveData({
        draft: {
          postText: editorState?.content,
          postImages: updatedImages,
          postVideos: updatedVideos,
        },
      });
    } else {
      await saveData({
        draft: {
          _id: editorState?.docid,
          postText: editorState?.content,
          postImages: updatedImages,
          postVideos: updatedVideos,
          updatedAt: new Date().toISOString(),
        },
      });
    }
    setIsDraftSaving(false);
    toast({
      title: "Draft saved successfully",
    });
  };

  const handleSendForApproval = async ({ editorState }) => {
    mixpanel.track(
      "Influencer Brand Collab Details - Linkedin Editor : Send for Approval - Clicked "
    );

    if (!editorState?.docid) {
      toast({
        title: "'Save' the draft before sending for approval",
        variant: "destructive",
      });
      return;
    }
    // get all the linkedin post drafts form collab and update the status to approval pending

    await saveData({
      draft: {
        _id: editorState?.docid,
        status: 1,
        submittedAt: new Date().toISOString(),
      },
    });

    toast({
      title: "Draft sent for approval successfully",
    });
  };

  // --------------- Accept Term and Conditions ----------------
  const handleAcceptCollab = async ({
    e,
    isAccepted,
    status,
  }: {
    e?: any;
    isAccepted?: any;
    status?: any;
  }) => {
    mixpanel.track(
      "Influencer Brand Collab Details - Accept Terms and Conditions : Clicked "
    );
    if (isAccepted) {
      const res = await saveData({
        tncAccepted: isAccepted,
        response: status,
      });
      if (res?.success) {
        handleConfettiClick(e);
        setOpenAcceptSuccess(true);
      }
    } else {
      toast({
        title: "Please accept the terms and conditions",
        variant: "destructive",
      });
    }
  };

  return (
    <>
      {window.innerWidth > 600 ? (
        <div className="flex w-screen h-screen font-inter">
          {showConfetti && (
            <div className="fixed top-0 left-0 z-[60]">
              <Confetti
                numberOfPieces={300}
                run={showConfetti}
                width={confettiConfig.width}
                height={confettiConfig.height}
                recycle={false}
                gravity={0.1}
                initialVelocityX={10}
                initialVelocityY={20}
              />
            </div>
          )}
          <BrandCollabSidebar
            navigateTo="/influencer/brandCollabs"
            children={
              <BrandCollabStepper
                collab={collab}
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
              />
            }
          />
          <div className="flex flex-col w-[260px] min-w-[260px]"></div>

          <div className="w-full max-w-6xl md:mx-auto py-3 md:py-6 lg:py-12 text-[#FFF] ">
            {/* Accept Opportunity - Campaign Overview */}
            {currentStep === 1 && (
              <AcceptOpportunityPage
                handleSubmit={handleSubmit}
                collab={collab}
                setCurrentStep={setCurrentStep}
                handleAcceptCollab={handleAcceptCollab}
                openAcceptSuccess={openAcceptSuccess}
                setOpenAcceptSuccess={setOpenAcceptSuccess}
                declineReason={declineReason}
                setDeclineReason={setDeclineReason}
                description={declineDescription}
                setDescription={setDeclineDescription}
              />
            )}

            {/* campaign draft - share draft - linkedin editor  */}
            {(currentStep === 2 || currentStep === 3) && (
              <ShareDraftPage
                collab={collab}
                handleSaveLinkedinDraft={handleSaveLinkedinDraft}
                handleSendForApproval={handleSendForApproval}
                setCurrentStep={setCurrentStep}
                isDraftSaving={isDraftSaving}
              />
            )}

            {/* Go Live  - Share Live Post Link */}
            {currentStep === 4 && (
              <GoLivePage
                collab={collab}
                PostData={PostData}
                SetPostData={SetPostData}
                handleSubmit={handleSubmit}
                loadingTracking={loadingTracking}
                collabId={collabId}
                handleTrackPost={handleTrackPost}
              />
            )}
          </div>
        </div>
      ) : (
        <ScreenAlert />
      )}
    </>
  );
};
